export function getApplicationUrl(): string {
  if (process.env.NODE_ENV === "production") {
    const url = window.location.origin;

    if (url === "https://salgadoscarvalho.eattake.com") {
      return "https://sal.eattake.com";
    }

    return url;
  }

  return process.env.VUE_APP_DEV_APP_URL || window.location.origin;
}
